module.exports = __webpack_public_path__ + "static/media/alexis-bledel-lose.47ca8d24.jpg";